export default __webpack_public_path__ + "static/media/cooking_and_baking.eb112fd9.jpg";